/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import connect from 'react-redux/es/connect/connect';
// actions
import { sendErrorMessage } from '@insticator/insticator-ui'; // iui-state
// component
import Upload from 'material/ctas/upload/upload';



/* ========== ~~~~~~~~~~ CTA : UPLOAD : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = () => ({
});

// map actions
const mapDispatchToProps = dispatch => ({
   sendErrorMessage: message => dispatch(sendErrorMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Upload);
